angular.module('env.loading', [
    'env.loading.loadingMixin'
]);